import { render, staticRenderFns } from "./VenteFiche.vue?vue&type=template&id=5b0f3078"
import script from "./VenteFiche.vue?vue&type=script&lang=js"
export * from "./VenteFiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports